import { computed, ref } from 'vue';

import { pluralize } from '@/utils/helpers/string-utils';

// TODO: Исправить правило, код очень запутанный
/* eslint-disable @typescript-eslint/no-use-before-define */
export default () => {
  const timer = ref();
  const nowDate = ref();
  const endTime = ref();
  const diff = ref(0);

  function createInterval() {
    timer.value = setInterval(() => {
      if (diff.value > 0) {
        diff.value = Math.max(0, diff.value -= 1000);
        return;
      }
      diff.value = 0;
      stopCountdown();
    }, 1000);
  }

  function onTabChange() {
    // стопорим таймер при переключении
    if (document.hidden) {
      clearInterval(timer.value);
    } else { // включаем при возвращений
      nowDate.value = new Date();
      diff.value = endTime.value.getTime() - nowDate.value;

      if (diff.value > 0) {
        createInterval();
        return;
      }

      diff.value = 0;
    }
  }

  function startCountdown(endDateTime) {
    timer.value = null;
    nowDate.value = new Date();
    endTime.value = new Date(endDateTime);
    diff.value = Math.max(endTime.value.getTime() - nowDate.value, 0);

    // если время уже закончилось - не включаем таймер
    if (diff.value <= 0) {
      return;
    }

    createInterval();
    window.document.addEventListener('visibilitychange', onTabChange);
  }

  function stopCountdown() {
    window.document.removeEventListener('visibilitychange', onTabChange);
    clearInterval(timer.value);
  }

  const days = computed(() => (diff.value / 1000) / 60 / 60 / 24);
  const roundedDays = computed(() => Math.floor(days.value));
  const hours = computed(() => Math.floor((diff.value % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
  const minutes = computed(() => Math.floor(diff.value / 1000 / 60) % 60);
  const seconds = computed(() => Math.floor(diff.value / 1000) % 60);
  const moreThanDay = computed(() => days.value >= 1);
  const hoursCaption = computed(() => pluralize(hours.value, ['час', 'часа', 'часов'], true));
  const minutesCaption = computed(() => pluralize(minutes.value, ['минута', 'минуты', 'минут'], true));

  const firstCell = computed(() => (moreThanDay.value
    ? { digit: roundedDays.value, caption: pluralize(roundedDays.value, ['день', 'дня', 'дней'], true) }
    : { digit: hours.value, caption: hoursCaption.value }));
  const secondCell = computed(() => (moreThanDay.value
    ? { digit: hours.value, caption: hoursCaption.value }
    : { digit: minutes.value, caption: minutesCaption.value }));
  const thirdCell = computed(() => (moreThanDay.value
    ? { digit: minutes.value, caption: minutesCaption.value }
    : { digit: seconds.value, caption: pluralize(seconds.value, ['секунда', 'секунды', 'секунд'], true) }));
  const isTimeOut = computed(() => diff.value === 0);

  return {
    startCountdown,
    stopCountdown,
    isTimeOut,
    firstCell,
    secondCell,
    thirdCell,
  };
};
